import Highcharts, { chart } from 'highcharts/highstock'
import { formatNumber } from '../utils/Number'
import { highchartsOptions } from './chart-options'

Highcharts.setOptions(highchartsOptions)

const create = (element) => {
    const parser = element.dataset.chartParser || 'normal'
    let options = {
        legend: false,
        type: 'area',
    }

    try {
        options = {
            ...options,
            ...JSON.parse(element.dataset.chartOptions),
        }
    } catch (e) {}

    const formatPoint = (point) => {
        return `<span style="color: ${point.color}">${point.series.name}: </span> <b>${formatNumber(
            point.y,
        )}</b>`
    }

    let chartOptions = {
        chart: {
            renderTo: element,
            alignTicks: false,
            spacingBottom: options.legend ? 50 : 20,
            type: options.type,
            animation: false,
            height: options.legend ? 400 : 300,
            zooming: {
                mouseWheel: false,
            },
        },
        credits: {
            enabled: false,
        },
        colors: [
            '#4555FF',
            '#0DC1AE',
            '#F94D4D',
            '#FFAE41',
            '#24CB61',
            '#57BFFF',
            '#8B79FF',
            '#FF7848',
        ],
        rangeSelector: {
            enabled: false,
        },
        plotOptions: {
            series: {
                stacking: 'normal',
            },
            area: {
                pointInterval: 24 * 3600 * 1000,
            },
        },
        title: null,
        legend: {
            enabled: options.legend,
            align: 'center',
            borderWidth: 0,
            layout: 'horizontal',
            y: 35,
        },
        navigator: {
            enabled: false,
        },
        scrollbar: {
            enabled: false,
        },
        tooltip: {
            formatter: function () {
                let s = []

                s.push(`<b>${Highcharts.dateFormat('%d. %m. %Y', this.x)}</b>`)

                if (parser === 'categories') {
                    s.push(`Celkem: <b>${formatNumber(this.points[0].total)}</b>`)
                }

                this.points.forEach((point) => s.push(formatPoint(point)))

                return s.join('<br>')
            },
        },
        series: [],
        xAxis: {
            minRange: 24 * 3600 * 1000,
        },
        yAxis: [
            {
                opposite: false,
                min: 0,
                labels: {
                    align: 'right',
                },
            },
        ],
    }

    const data = JSON.parse(element.dataset.chartData)

    chartOptions.series = Object.entries(data)
        .reduce((series, [key, item]) => {
            Object.entries(item).forEach(([categoryId, value]) => {
                const index = parseInt(categoryId)
                if (!series[index]) {
                    series[index] = {
                        name: value.name,
                        data: [],
                    }
                }
                series[index].data.push([parseInt(key) - 1 * 60 * 60 * 1000, value.value])
            })

            return series
        }, [])
        .filter(Boolean)

    new Highcharts.stockChart(chartOptions)
}

$(document).on('dom:change', function (event) {
    event.target.querySelectorAll('.chart-stack').forEach(create)
})
document.querySelectorAll('.chart-stack').forEach(create)